import React from "react";
import "./ResourceBar.css";

const ResourceBar = ({ resources }) => {
  if (!resources) return null; // si no hay datos, no renderiza nada

  // Lista de recursos a mostrar en pantalla
  const items = [
    { key: "blood_earth", icon: "🩸", label: "Sangre de Terra" },
    { key: "biomass", icon: "🧬", label: "Biomasa" },
    { key: "material", icon: "⚙️", label: "Material" },
    { key: "crystals", icon: "💎", label: "Cristales" },
    { key: "spice", icon: "✨", label: "Especia" },
    { key: "energy", icon: "⚡", label: "Energía" },
    { key: "tech", icon: "🔧", label: "Tech" },
    { key: "psi", icon: "🧠", label: "Psi" },
  ];

  return (
    <div className="resource-bar">
      {/* Renderiza cada recurso con su icono, nombre y valor */}
      {items.map((res) => (
        <div key={res.key} className="resource-item">
          <span>{res.icon}</span>
          <span>{res.label}:</span>
          {/* Math.floor elimina decimales */}
          <span className="resource-amount">{Math.floor(resources[res.key])}</span>
        </div>
      ))}
    </div>
  );
};

export default ResourceBar;